import { render, staticRenderFns } from "./MotorPoliciesLTA.vue?vue&type=template&id=a3e11566&"
import script from "./MotorPoliciesLTA.vue?vue&type=script&lang=js&"
export * from "./MotorPoliciesLTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports